<div id="integrationCarteiraPedido" class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Sincronizar carteira de pedidos com o ERP
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="integrationCarteiraPedidoPeriodicidade" class="col-form-label">Periodicidade</label>
                            <select class="form-control" name="integrationCarteiraPedidoPeriodicidade" id="integrationCarteiraPedidoPeriodicidade" 
                                [ngModel]="entity.periodicidade || ''" (ngModelChange)="entity.periodicidade = $event ? $event : null"
                                #integrationCarteiraPedidoPeriodicidade="ngModel" required="required">
                                <option *ngFor="let periodicidade of periodicidades" [ngValue]="periodicidade.id">{{getDescricaoPeriodicidade(periodicidade.id)}}</option>
                            </select>  
                            <p class="form-text text-muted">Periodicidade da sincronização da carteira de pedidos</p>
                            <sgt-form-control-error
                                *ngIf="integrationCarteiraPedidoPeriodicidade.errors && integrationCarteiraPedidoPeriodicidade.errors.required && integrationCarteiraPedidoPeriodicidade.dirty"
                                msgError="A periodicidade é obrigatória">
                            </sgt-form-control-error>                                       
                        </div>                        
                    </div> 

                    <!-- Geral -->
                    <div class="row" *ngIf="isPeriodicidadeGeral()">
                        <div class="col-12">
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label" for="integrationCarteiraPedidoDataInicialBase">Data de Entrega Inicial</label>
                                    <sgt-datepicker [(ngModel)]="entity.dataInicialBase" name="integrationCarteiraPedidoDataInicialBase" id="integrationCarteiraPedidoDataInicialBase"
                                        #integrationCarteiraPedidoDataInicialBase="ngModel" [ngControl]="integrationCarteiraPedidoDataInicialBase" required="required">
                                    </sgt-datepicker>
                                    <p class="form-text text-muted">Irá sincronizar a carteira de pedidos com entregas a partir desta data</p>
                                    <sgt-form-control-error
                                        *ngIf="integrationCarteiraPedidoDataInicialBase.errors && integrationCarteiraPedidoDataInicialBase.errors.required && integrationCarteiraPedidoDataInicialBase.dirty"
                                        msgError="A data inicial é obrigatória">
                                    </sgt-form-control-error>  
                                </div>                         
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="alert alert-warning" role="alert">
                                        <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Atenção! Se você informar uma data de entrega inicial muito antiga a sincronização pode levar vários minutos.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="execute()" [disabled]="form.invalid">
                    Sincronizar
                </button>              
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>